import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import Error from './error'
import Error403 from './error403'
import Error404 from './error404'
import Error500 from './error500'

import {
  LAYOUT_COMMON_ERROR_403,
  LAYOUT_COMMON_ERROR_404,
  LAYOUT_COMMON_ERROR_500,
  LAYOUT_COMMON_ERROR_UNKNOWN
} from '../navigation'

const Router = () => (
  <>
    <Switch>
      <Route path={LAYOUT_COMMON_ERROR_403}>
        <Error403 />
      </Route>
      <Route path={LAYOUT_COMMON_ERROR_404}>
        <Error404 />
      </Route>
      <Route path={LAYOUT_COMMON_ERROR_500}>
        <Error500 />
      </Route>
      <Route path={LAYOUT_COMMON_ERROR_UNKNOWN}>
        <Error />
      </Route>
      <Redirect to={LAYOUT_COMMON_ERROR_UNKNOWN} />
    </Switch>
  </>
)

export default Router
